import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    text: {
        fontFamily: 'Inter',
        color: 'rgba(255, 255, 255, 0.9)',
        whiteSpace: 'pre-wrap',
        fontSize: '14px',
        lineHeight: '1.5'
    }
}));

